import { useState } from "react"

export interface UseFilter {
  typeFilter?: number | string
  dateFrom: string
  dateTo: string
}

export const useFilter = ({ typeFilter, dateFrom, dateTo }: UseFilter) => {

  const [filter, setFilter] = useState<UseFilter>({
    typeFilter,
    dateFrom,
    dateTo
  })

  const handleChangeFilter = (params: Partial<UseFilter>) => {
    setFilter((prev) => ({ ...prev, ...params }))
  }

  return {
    filter,
    handleChangeFilter
  }
}
